module.exports = __webpack_public_path__ + "img/danger_icon.ac687f57.png";